import { Component, input, OnDestroy, OnInit, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

import { ReplaySubject, Subscription } from 'rxjs';

import { UiPalette } from '../../../types/UiPalette.type';

@Component({
  selector: 'eiq-slide-toggle',
  templateUrl: 'slide-toggle.component.html',
  styleUrls: ['slide-toggle.component.scss']
})
export class SlideToggleComponent implements OnInit, OnDestroy, ControlValueAccessor {
  color = input<UiPalette>('primary');
  label = input<string>();
  labelPosition = input<'before' | 'after'>('after');
  testId = input<string>();

  onChange: (value: boolean) => void;
  onTouched: () => void;

  currentValue: boolean;

  private toggle$ = new ReplaySubject<boolean>(1);
  private subscriptions: Subscription[] = [];

  constructor(@Self() public ngControl: NgControl) {
    this.ngControl.valueAccessor = this;
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.toggle$.subscribe((input: boolean) => {
        this.onTouched();
        this.onChange(input);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(toggle: boolean): void {
    this.currentValue = toggle;
  }

  setValue($event: MatSlideToggleChange): void {
    this.currentValue = $event.checked;
    this.toggle$.next($event.checked);
  }

  clearValue(): void {
    this.currentValue = false;
    this.toggle$.next(false);
  }

  setDisabledState?(_isDisabled: boolean): void {
    // Implement if needed
  }
}
